import React, { useEffect, useState } from "react";
import { HiPlay, HiCheck, HiForward, HiArrowPath, HiStop } from "react-icons/hi2";
import styles from './TurnTimeline.module.css';
import { debateTypes } from '../debateFormatsDataV3';
import Button from '../../ui/Button';

const TurnTimeline = ({state, arena, activeTurn, formatId, isModerator, handleNextTurn }) => {
  //const [debateState, setDebateState] = useState(null);
  //const [timeLeft, setTimeLeft] = useState(0);
   const formatData = debateTypes.find(m => m.id === formatId?.toLowerCase()) || {};
  const sequence = formatData.turns || [];
  const currentTurnId = activeTurn?.id;
  const timeLeft = activeTurn?.remainingTimeForTurn || 0;
  //console.log('TurnTimeline props:', { formatId, formatData, activeTurn });
  /*useEffect(() => {
    const turn = DEBATE_FORMATS_TURNTIMER[formatId].sequence.find((t) => t.id === currentTurnId);
	
    if (!turn) return;

    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - turnStartTime) / 1000);
      const remaining = Math.max(turn.duration - elapsed, 0);
      setTimeLeft(remaining);

      if (remaining === 0) {
        handleAutoAdvance();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [formatId]);*/

  /*const handleAutoAdvance = async () => {
    const sequence = DEBATE_FORMATS_TURNTIMER[formatId].sequence;
    const idx = sequence.findIndex((t) => t.id === currentTurnId);

    if (idx < sequence.length - 1) {
      const nextTurn = sequence[idx + 1];
	  handleNextTurn({
        currentTurnId: nextTurn.id,
        turnStartTime: Date.now(),
      });
    }
  };*/

  /*const handleRestartTurn = async () => {
	  handleNextTurn({
        currentTurnId: currentTurnId,
        turnStartTime: Date.now(),
      });
  };

  const handleEndDebate = async () => {
	handleNextTurn({
        currentTurnId: currentTurnId,
        turnStartTime: turnStartTime,
		status: "ended"
    });
  };*/

  return (
    <div className={styles.timeline}>
      <h3 className={styles.title}>{formatData.name} Timeline</h3>
      <div className={styles.stepper}>
        {sequence.map((turn, index) => {
          const isActive = turn.id === currentTurnId;
          const elapsed = isActive && turn?.durationSec > 0  ? turn.durationSec - timeLeft  : turn.durationSec;
          const progress = isActive  ? Math.min((elapsed / turn.durationSec) * 100, 100) : turn.id === currentTurnId ? 0 : 100;

          return (
            <div
              key={turn.id}
			        title={turn.description}
              className={`${styles.step} ${
                isActive
                  ? styles.active
                  : index < sequence.findIndex((t) => t.id === currentTurnId)
                  ? styles.completed
                  : ""
              }`}
            >
              <div className={styles.stepCircle}>
                {isActive ? (
                  <HiPlay />
                ) : index < sequence.findIndex((t) => t.id === currentTurnId) ? (
                  <HiCheck />
                ) : null}
              </div>
              <div className={styles.stepInfo}>
                <span className={styles.label}>{turn.name}</span>
                {isActive && (
                  <>
                    <div className={styles.progressBar}>
                      <div
                        className={styles.progressFill}
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                    <p className={styles.timeLeft}>{timeLeft}s left</p>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/*isModerator && (
        <div className={styles.controls}>
          <Button onClick={handleAutoAdvance}>
            <HiForward /> Skip Turn
          </Button>
          <Button onClick={handleRestartTurn}>
            <HiArrowPath /> Restart Turn
          </Button>
          <Button onClick={handleEndDebate}>
            <HiStop /> End Debate
          </Button>
        </div>
      )*/}
    </div>
  );
};

export default TurnTimeline;



/*export default function TurnTimeline({ formatId, currentTurnId }) {
  const formatData = DEBATE_FORMATS_TURNTIMER[formatId];
  const sequence = formatData.sequence;

  return (
    <div className={styles.timeline}>
      <h3 className={styles.title}>{formatData.name} Timeline</h3>
      <ul className={styles.turnList}>
        {sequence.map((turn) => (
          <li
            key={turn.id}
            className={`${styles.turnItem} ${turn.id === currentTurnId ? styles.active : ""}`}>
            <div className={styles.label}>
              <span>{turn.label}</span>
              <small>{turn.duration / 60} min</small>
            </div>
            <p className={styles.desc}>{turn.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};*/
